import Sidebar from "./Sidebar";
import Topbar from "./Topbar";

export default function Layout({ children }) {
  return (
    <div className="flex min-h-screen" style={{ background: "var(--bg-base)" }} data-testid="layout">
      <Sidebar />
      <div className="flex-1 flex flex-col min-w-0">
        <Topbar />
        <main className="flex-1 px-8 py-6 max-w-[1600px] w-full" style={{ color: "var(--text-primary)" }}>
          {children}
        </main>
      </div>
    </div>
  );
}
